import { put, select, take } from 'redux-saga/effects';
import { push } from 'redux-little-router';
import { getFormValues } from 'redux-form/immutable';
import { setReceiptsLink, updateDraft } from 'modules/Taps/components/NDFL3Light/redux/actions';
import {
  SET_RECEIPTS_LINK_SUCCESS,
  UPDATE_DRAFT_SUCCESS,
} from 'modules/Taps/components/NDFL3Light/redux/actionTypes';
import { STEP_DEDUCTION_FORM } from '../constants';

export function* submitDeductionsSaga({ payload: { getNextStep } }) {
  const formData = yield select(getFormValues(STEP_DEDUCTION_FORM));

  yield put(setReceiptsLink(formData));
  const { payload: updatedDraft } = yield take(SET_RECEIPTS_LINK_SUCCESS);

  yield put(
    updateDraft({
      draft: updatedDraft
        .set('currentFormId', 'submit')
        .setIn(['payload', 'deductionSelector', 'socialDeduction'], true)
        .setIn(['payload', 'sheetE2', 'charityLiveDeductionSelected'], true),
    }),
  );
  yield take(UPDATE_DRAFT_SUCCESS);
  yield put(push({ query: { step: getNextStep() } }, { persistQuery: true }));
}
